export default {
  title: 'Ohodnoťte přednášku',
  questions: [
    { id: 'kvalita', type: 'rate', label: 'Kvalita přednášky' },
    { id: 'prednasajuci', type: 'rate', label: 'Úroveň přednášejícího' },
    { id: 'ine', type: 'multiline', label: 'Jiné připomínky' },
  ],
}



// WEBPACK FOOTER //
// ./src/content/devdata/addons/feedback/presentation.js